import React from 'react';

const WrongPagePF = () => {
  return(
    <div className='wrong_page_container center centerWrongPage'>
      <span className='title'>You Don’t Have Access to This Page </span>
      <p style={{marginLeft:'12px'}}>
      It looks like you have a College Board professional account, but you don’t have access to BigFuture College Profiles. If you believe you should have access, please email us at <a href="mailto:collegesurvey@collegeboard.org">collegesurvey@collegeboard.org</a> to request an Enrollment Manager (EM) role for BigFuture College Profiles. 
      
      </p>
    </div>
  );
}
export default WrongPagePF;